import * as c from '../constants/ApprovalRequestConstants'
import { LOGOUT_USER } from '../constants/UserConstants'

const initialState = {
  entities: {},
  result: [],
  selectedApprovalRequest: null,
  arType: null,
  processingApprovalRequest: false, // the Process Approval Request form is being displayed
  fetching: false,
  fetched: false,
  error: null,
  selectedEducationPeriod: null,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case LOGOUT_USER:
      return initialState

    case c.FETCH_APPROVAL_REQUESTS_PENDING:
      return { ...state, fetching: true, fetched: false, error: null }

    case c.FETCH_APPROVAL_REQUESTS_FULFILLED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        arType: payload.arType,
        entities: payload.data?.entities ?? {},
        result: payload.data?.result ?? [],
      }

    case c.FETCH_APPROVAL_REQUESTS_REJECTED:
      return { ...state, fetching: false, fetched: false, error: payload }

    case c.UPDATE_SELECTED_APPROVAL_REQUEST:
      return { ...state, selectedApprovalRequest: payload }

    case c.CLEAR_SELECTED_APPROVAL_REQUEST:
      return { ...state, selectedApprovalRequest: null }

    case c.START_PROCESSING_APPROVAL_REQUEST:
      return { ...state, processingApprovalRequest: true }

    case c.STOP_PROCESSING_APPROVAL_REQUEST:
      return { ...state, processingApprovalRequest: false }

    case c.SUBMIT_APPROVAL_REQUEST_FULFILLED:
      return {
        ...state,
        entities: {
          ...state.entities,
          approvalRequests: {
            ...state.entities.approvalRequests,
            [payload.id]: {
              ...state.entities.approvalRequests[payload.id],
              etsApprovalStatus: payload.etsApprovalStatus,
              comments: payload.comments,
            },
          },
        },
      }

    case c.FETCH_APPROVAL_REQUEST_DETAIL_PENDING:
      return {
        ...state,
        entities: {
          ...state.entities,
          approvalRequests: {
            ...state.entities.approvalRequests,
            [payload.id]: {
              ...state.entities.approvalRequests[payload.id],
              fetching: true,
              fetched: false,
              error: null,
            },
          },
        },
      }

    case c.FETCH_APPROVAL_REQUEST_DETAIL_FULFILLED:
      return {
        ...state,
        entities: {
          ...state.entities,
          approvalRequests: {
            ...state.entities.approvalRequests,
            [payload.id]: {
              ...state.entities.approvalRequests[payload.id],
              ...payload.data,
              fetching: false,
              fetched: true,
            },
          },
        },
      }

    case c.FETCH_APPROVAL_REQUEST_DETAIL_REJECTED:
      return {
        ...state,
        entities: {
          ...state.entities,
          approvalRequests: {
            ...state.entities.approvalRequests,
            [payload.id]: {
              ...state.entities.approvalRequests[payload.id],
              error: payload.error,
            },
          },
        },
      }

    case c.SET_APPROVAL_REQUESTS_SELECTED_EDUCATION_PERIOD:
      return {
        ...state,
        selectedEducationPeriod: payload,
      }

    default:
      return state
  }
}
